module.exports = __webpack_public_path__ + "static/img/020_5.23021c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/020_5.jpg
// module id = XQUo
// module chunks = 1